<template>
  <div class="zone-item">
    <div class="zone-image-container">
      <div class="zone-image-preview">
        <img
          :src="zone.image ? zone.image : sensorDisplay.imagePlaceholder"
          :alt="zone.name"
          height="72px"
          width="72px"
        >
      </div>
    </div>
    <div class="zone-data-container">
      <div class="zone-name-container">
        <span class="zone-name"> {{ zone.name }} </span>
        <span
          v-if="canEditZone"
          class="edit-zone"
          @click="$emit('edit-zone', zone)"
        >
          <v-icon size="small"> $faCog </v-icon>
          <span class="edit-zone-text">Edit Sensor</span>
        </span>
      </div>
      <div class="zone-item-data">
        <div class="zone-sensor-type">
          {{ sensorDisplay.type }}
        </div>
        <div v-if="sensorDisplay.type!=='No Sensor Details'">
          <v-icon
            class="status mr-2"
            size="12"
            :color="connectionColor"
          >
            $faCircle
          </v-icon>
          <span class="text-caption">{{ zone.status }}</span>
        </div>
        <div v-if="zoneOnline">
          <font-awesome-layers
            v-if="signalUnavailable"
            style="vertical-align: -0.125em;"
            class="fa-lg mr-4"
          >
            <font-awesome-icon
              :icon="['fad','signal-alt']"
              :style="{ color: '#cecece' }"
            />
            <font-awesome-icon
              :icon="['fas','question-circle']"
              :style="{ color: '#535353' }"
              transform="shrink-7 down-9 right-12"
            />
          </font-awesome-layers>
          <v-icon
            v-else
            :class="[{'fa-pulse': signalLoading}, 'mr-2']"
            :color="signalDisplay.color"
            :style="{'--fa-secondary-color': '#E1EBEE'}"
            size="18"
          >
            {{ signalDisplay.icon }}
          </v-icon>
          <span class="text-caption">{{ signalDisplay.text }}</span>
        </div>
        <div v-if="zone.lowBattery">
          <v-icon
            color="error"
            class="mr-2"
            size="18"
          >
            $faBatteryQuarter
          </v-icon>
          <span class="text-caption">Low Battery</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getModel, getConnectionColor, getSignalStrength, getSensorDisplay, getSignalDisplay, connections, signals } from '@/helpers/sensor-connectivity.js'

  export default {
    name: 'ActivityZoneListItem',
    props: {
      zone: Object,
      signalError: Boolean,
      signalLoading: Boolean,
    },
    computed: {
      ...mapGetters({
        canEditZone: 'Permissions/canManageSelectedOrg',
      }),
      zoneOnline () {
        return this.zone.status === connections.ONLINE
      },
      signalUnavailable () {
        return !this.signalLoading && (this.signalError || this.signal === signals.UNAVAILABLE)
      },
      signal () {
        const { sensor, RSSI } = this.zone
        return getSignalStrength({ style: sensor.style, RSSI })
      },
      model () {
        const { style, generation, firmwareId } = this.zone.sensor
        return getModel({ style, generation, firmwareId })
      },
      connectionColor () {
        return getConnectionColor({ connection: this.zone.status })
      },
      sensorDisplay () {
        return getSensorDisplay({ model: this.model })
      },
      signalDisplay () {
        return getSignalDisplay({ loading: this.signalLoading, signal: this.signal })
      },
    },
  }
</script>

<style lang="scss">
.zone-item {
    height: 134px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    & + .zone-item {
      border-top: 1px solid rgba(0,0,0,0.2);
    }
  }
  .zone-image-container {
    flex: none;
    margin: auto 0;
  }
  .zone-image-preview {
    height: 74px;
    width: 74px;
    border-radius: 4px;
  }
  .zone-data-container {
    flex: 1 1 auto;
    height: 74px;
    margin: auto 0 auto 30px;
  }
  .zone-name-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    height: 50%;
  }
  .zone-name {
    // refactor to h6 class
    flex: none;
    font-family: "Degular", sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.21px;
    color: black;
    display: block;
  }
    .edit-zone {
    flex: none;
    cursor: pointer;
    font-size: 14px;
    letter-spacing: 1px;
    & > .v-icon {
      margin: 0 5px;
    }
    .edit-zone-text {
      visibility: hidden;
      text-transform: uppercase;
      vertical-align: middle;
    }
    & * {
      color: #C4C4C4;
    }
    &:hover {
      & * {
        color: $muted;
      }
      .edit-zone-text {
        visibility: visible;
      }
    }
  }
  .zone-item-data {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    height: 50%;
    & > div {
      flex: 0 0 170px;
      margin: auto 0;
    }
  }
  .status {
    font-size: 12px;
  }
  .zone-sensor-type {
    // refactor to Overline class
    font-family: "Degular", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    color: #535353;
    letter-spacing: 1px;
  }
  .text-caption {
    font-size: 14px;
    line-height: 18px;
    vertical-align: middle;
  }
</style>
